import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParametroSistemaService {

  constructor(private readonly httpClient: HttpClient) { }

  getParametroSistema(cdParamePar: string): Observable<any> {
    return this.httpClient.get( `/apiconnect/parameters-vt/system?parametro=${cdParamePar}` );
  }
}
